export default __webpack_public_path__ + "static/media/lamb_&_beef_khebab.6fabd3ff.jpg";